import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import AdminGeneralFaqSc from "../../../AdminDasboard/AdminFaqs/AdminFaqReply/index.sc";
import { getGeneralFaqReplyByAdmin } from "../../../api/FAQ/Admin/GenralFAQ/getRepliedFaqByFaqId";
import { getFaqByFaqId } from "../../../api/FAQ/UserFaq/getFaqByFaqId";
import { useAuthContext } from "../../../hooks";
import PersonsalQueryResponseSc from "./index.sc";

function Index() {
  const navigate = useNavigate();
  const params = useParams();
  const [personalResponse, setPersonalResponse] = useState<any[]>([]);
  const auth = useAuthContext();
  const fetchOrgUserPersonalFaq = async () => {
    await getGeneralFaqReplyByAdmin(auth?.userInfo?.orgs[0]?.id, params?.faqId)
      .then((e) => {
        setPersonalResponse(e);
      })
      .catch((e) => console.log(e));
  };
  const [generalId, setGeneralId] = useState<any>([]);
  const fetchOrgUserSingleFaq = async () => {
    await getFaqByFaqId(auth?.userInfo?.orgs[0]?.id, params?.faqId)
      .then((e) => {
        setGeneralId(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchOrgUserPersonalFaq();
    // fetchOrgUserOrgGoals();
    fetchOrgUserSingleFaq();
  }, []);
  console.log(generalId);
  return (
    <AdminGeneralFaqSc>
      <div className="container_reply">
        {generalId?.map((data: any) => {
          return (
            <>
              <div className="heading">
                <div className="member_name">
                  Employee Name{""}:{""}
                  <span style={{ fontSize: "15px", margin: "10px" }}>
                    {data?.name}
                  </span>
                </div>
                <div className="faq_type">FAQ Type {""}:</div>
              </div>
              <div className="query_content">{data?.quest}</div>
            </>
          );
        })}
        <div className="admin_reply_container">
          {personalResponse?.map((data: any) => {
            return (
              <>
                <div>{data?.response}</div>
              </>
            );
          })}
        </div>
      </div>
    </AdminGeneralFaqSc>
  );
}

export default Index;
